import { useLocation } from "react-router-dom";
import getObjFromSearchQuery from "../../utils/getObjFromSearchQuery";

// A param with no `=` ("?sort") parses to `true`, which none of the readers below can use —
// `JSON.parse(true)` yields a boolean where a grid expects its sort object. Treat it as absent,
// so every field here is the string its consumers already assume it is.
const asText = (value: string | true | undefined) =>
  typeof value === "string" ? value : undefined;

const useQueryState = () => {
  const { search } = useLocation();
  const query = getObjFromSearchQuery(search);

  const sort = asText(query.sort) ?? "{}";
  const pagination = asText(query.pagination) ?? "{}";
  const filter = asText(query.filter) ?? "{}";

  return {
    urlSort: sort,
    urlSortObject: JSON.parse(sort),
    urlPagination: pagination,
    urlPaginationObject: JSON.parse(pagination),
    urlFilters: filter,
    urlFiltersObject: JSON.parse(filter),
    urlAccountId: asText(query.accountId),
    urlActiveTab: asText(query.activeTab),
    urlTimeStamp: asText(query.timestamp),
    urlOpenPosition: asText(query.openPosition) ?? "",
  };
};

export default useQueryState;
